module.exports = __webpack_public_path__ + "static/media/gb-eng.7caecb78.svg";